import { IntlShape } from 'react-intl';

export const formatErrorMessage = <T>(error: any, errorType: T, intl: IntlShape) => {
  return (
    errorType[(error?.error ?? error?.message ?? error?.code ?? error) as keyof T] ??
    intl.formatMessage(
      {
        id: 'app.unknown_error_with_reason',
        defaultMessage: 'Упс, щось пішло не так. Спробуйте ще раз, або зв`яжіться з тех.підтримкою({error}).',
      },
      {
        error:
          error?.error ??
          error?.message ??
          error?.code ??
          intl.formatMessage({
            id: 'app.unknown_error',
            defaultMessage: 'Невідома помилка!',
          }),
      }
    )
  );
};
